import { AuthGuard } from './core/guards/auth.guard';
import { ErrorCodes } from './core/constants/pol.enums';
import { ErrorComponent } from './core/pages/error/error.component';
import { HeliosSsoComponent } from './core/pages/helios-sso/helios-sso.component';
import { launchDarklyResolver } from './core/guards/launch-darkly.resolver';
import { LayoutComponent } from './core/layout/layout.component';
import { LegacySsoComponent } from './core/pages/legacy-sso/legacy-sso.component';
import { MpCardDetailsComponent } from './shared/components/mp-card-details/mp-card-details.component';
import { NgModule } from '@angular/core';
import { playgroundComponent } from './core/pages/playground/playground.component';
import { Routes, RouterModule } from '@angular/router';
import { SignOutGuard } from './core/pages/sign-out/sign-out.guard';
import { UnauthorizedErrorComponent } from './core/pages/unauthorized-error/unauthorized-error.component';
import { userAgreementResolver } from './core/guards/user-agreement.resolver';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    data: {
      breadcrumb: 'Home'
    },
    canActivateChild: [AuthGuard],
    resolve: [userAgreementResolver],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'member-look-up',
        loadChildren: () => import('./features/member/member.module').then((m) => m.MemberModule),
        data: {
          breadcrumb: 'Member Look Up'
        }
      },
      {
        path: 'security-management',
        loadChildren: () =>
          import('./features/security-management/security-management.module').then((m) => m.SecurityManagementModule),
        data: {
          hideBreadcrumb: false
        }
      },
      {
        path: 'clinical',
        loadChildren: () => import('./features/clinical/clinical.module').then((m) => m.ClinicalModule),
        data: {
          hideBreadcrumb: false
        }
      },
      {
        path: 'user',
        loadChildren: () => import('./features/user/user.module').then((m) => m.UserModule),
        data: {
          hideBreadcrumb: true
        }
      },
      {
        path: 'auth-entry',
        loadChildren: () => import('./features/auth-entry/auth-entry.module').then((m) => m.AuthEntryModule),
        data: {
          hideBreadcrumb: true
        }
      },
      {
        path: 'upmc-health-plan-imp-notices',
        component: MpCardDetailsComponent,
        data: {
          breadcrumb: 'UPMC Health Plan Important Notices'
        }
      },
      {
        path: 'pharmacy-updates',
        component: MpCardDetailsComponent,
        data: {
          breadcrumb: 'Pharmacy Updates'
        }
      },
      {
        path: 'education-webinars',
        component: MpCardDetailsComponent,
        data: {
          breadcrumb: 'Education/Webinars'
        }
      },
      {
        path: 'new-with-Upmc',
        component: MpCardDetailsComponent,
        data: {
          breadcrumb: "What's New with UPMC Health Plan"
        }
      },
      {
        path: 'error',
        component: ErrorComponent,
        data: {
          hideBreadcrumb: true,
          errorCode: ErrorCodes.NotFound
        }
      },
      {
        path: 'login-error',
        component: ErrorComponent,
        data: {
          hideBreadcrumb: true,
          errorCode: ErrorCodes.LoginFailed
        }
      },
      {
        path: 'helios-sso',
        component: HeliosSsoComponent,
        data: {
          hideBreadcrumb: true
        }
      },
      {
        path: 'legacy-sso',
        component: LegacySsoComponent,
        data: {
          hideBreadcrumb: true
        }
      },
      {
        path: 'playground',
        component: playgroundComponent,
        data: {
          hideBreadcrumb: true
        }
      },
      {
        path: 'claims-billing',
        loadChildren: () => import('./features/claims-billing/claims-billing.module').then((m) => m.ClaimsBillingModule),
      }
    ]
  },
  {
    path: 'unauthorized',
    pathMatch: 'full',
    component: UnauthorizedErrorComponent
  },
  {
    path: 'sign-in-error',
    pathMatch: 'full',
    component: UnauthorizedErrorComponent
  },
  {
    path: 'signout',
    pathMatch: 'full',
    loadChildren: () => import('./core/pages/sign-out/sign-out.module').then((m) => m.SignOutModule),
    canActivate: [SignOutGuard]
  },
  {
    path: 'provider-online-login-redirect',
    resolve: [launchDarklyResolver],
    loadChildren: () => import('./core/pages/finish-sign-in/finish-sign-in.module').then((m) => m.FinishSignInModule)
  },
  {
    path: 'provider-online-sso-login-redirect',
    loadChildren: () => import('./core/pages/finish-sign-in-legacy/finish-sign-in-legacy.module').then((m) => m.FinishSignInLegacyModule)
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
